export var ActiveRequestsType = {
    fixtures: "fixtures",
    outrights: "outrights"
};
//# sourceMappingURL=ActiveRequests.js.map